{
  "actionbar.actions": "Acciones",
  "actionbar.actionsAvailable": "Acciones disponibles.",
  "actionbar.clearSelection": "Borrar selección",
  "actionbar.selected": "{count, plural, =0 {Nada seleccionado} one {# seleccionado} other {# seleccionados}}",
  "actionbar.selectedAll": "Todos seleccionados",
  "actionbutton.pending": "pendiente",
  "breadcrumbs.more": "Más elementos",
  "button.pending": "pendiente",
  "calendar.invalidSelection": "{selectedCount, plural, one {La fecha seleccionada no está disponible} other {Las fechas seleccionadas no están disponibles}}.",
  "combobox.loading": "Cargando…",
  "combobox.loadingMore": "Cargando más…",
  "combobox.noResults": "Sin resultados",
  "contextualhelp.help": "Ayuda",
  "contextualhelp.info": "Información",
  "datepicker.endTime": "Hora de finalización",
  "datepicker.startTime": "Hora de inicio",
  "datepicker.time": "Hora",
  "dialog.alert": "Alerta",
  "dialog.dismiss": "Descartar",
  "dropzone.replaceMessage": "Suelte el archivo para reemplazar",
  "inlinealert.informative": "Información",
  "inlinealert.negative": "Error",
  "inlinealert.notice": "Advertencia",
  "inlinealert.positive": "Éxito",
  "label.(optional)": "(opcional)",
  "label.(required)": "(obligatorio)",
  "listview.loading": "Cargando…",
  "listview.loadingMore": "Cargando más…",
  "menu.loading": "Cargando…",
  "menu.loadingMore": "Cargando más…",
  "menu.moreActions": "Más acciones",
  "menu.noResults": "Sin resultados",
  "menu.unavailable": "No disponible, ampliar para más detalles",
  "notificationbadge.indicatorOnly": "Nueva actividad",
  "notificationbadge.plus": "{notifications}+",
  "picker.loading": "Cargando…",
  "picker.loadingMore": "Cargando más…",
  "picker.placeholder": "Seleccionar…",
  "picker.selectedCount": "{count, plural, =0 {Ningún elemento seleccionado} one {# elemento seleccionado} other {# elementos seleccionados}}",
  "sidepanel.collapse": "Contraer el panel lateral",
  "sidepanel.expand": "Expandir el panel lateral",
  "slider.maximum": "Máximo",
  "slider.minimum": "Mínimo",
  "table.cancel": "Cancelar",
  "table.drag": "Arrastrar",
  "table.editCell": "Editar celda",
  "table.loading": "Cargando…",
  "table.loadingMore": "Cargando más…",
  "table.resizeColumn": "Cambiar el tamaño de la columna",
  "table.save": "Guardar",
  "table.sortAscending": "Orden ascendente",
  "table.sortDescending": "Orden descendente",
  "tag.actions": "Acciones",
  "tag.hideButtonLabel": "Mostrar menos",
  "tag.noTags": "Ninguno",
  "tag.showAllButtonLabel": "Mostrar todo ({tagCount, number})",
  "toast.clearAll": "Borrar todo",
  "toast.collapse": "Contraer",
  "toast.showAll": "Mostrar todo",
  "treeview.loadingMore": "Cargando más…"
}
